import { EligibilityRequestBody } from '@/modules/Users/pages/Patient/components/RegisterPatient/RegisterPatient.types'

class SendEligibilityCheck {
  toPersistence(data: EligibilityRequestBody) {
    return {
      idPaciente: data?.patient?.id,
      carteiraConvenio: data?.patient?.cardNumber,
    }
  }
}

export default new SendEligibilityCheck()
